import { mediaUrl, imageUrl } from '../helpers'

interface Props {
  character?: wowaudit.Character | wowaudit.CharacterReference
  className?: string
}

const CharacterAvatar = ({ character, className }: Props) => {
  return (
    <img
      className={`rounded-full ${className}`}
      src={mediaUrl(character, 'avatar')}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null
        currentTarget.src = imageUrl('bnet-temp.png')
      }}
    />
  )
}

export default CharacterAvatar
